import React from 'react';
import ReactDOM from 'react-dom';
import Uploader from './Uploader';
import Copyright from './Copyright';
import Ad from './Advertisement';
import reportWebVitals from './reportWebVitals';
import Disclaimer from './components/Disclaimer'

ReactDOM.render(
  <React.StrictMode>
    <Uploader />
  </React.StrictMode>,
  document.getElementById('upload-form')
);

ReactDOM.render(
  <Ad adNum={2} />,
  document.getElementById('landing-ad')
);

ReactDOM.render(
  <Copyright />,
  document.getElementById('copyright')
);

ReactDOM.render(
  <Disclaimer />,
  document.getElementById('cookie-disclaimer')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
